"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Gender = exports.RateCodeToPaymentMethod = exports.Bool = exports.PaymentFrequency = exports.State = exports.Scale = void 0;
const utils_1 = require("./utils");
const common_1 = require("./common");
const whics_1 = require("./whics");
exports.Scale = (0, utils_1.reverseHashMap)(whics_1.Scale, common_1.Scale);
exports.State = (0, utils_1.reverseHashMap)(whics_1.State, common_1.State);
exports.PaymentFrequency = (0, utils_1.reverseHashMap)(whics_1.PaymentFrequency, common_1.PaymentFrequency);
exports.Bool = {
    Y: true,
    N: false
};
exports.RateCodeToPaymentMethod = {
    DirectDebit: common_1.PaymentMethod.DirectDebit,
    Other: common_1.PaymentMethod.CreditCard,
    Braintree: common_1.PaymentMethod.Braintree
};
exports.Gender = (0, utils_1.reverseHashMap)(whics_1.Gender, common_1.Gender);
//# sourceMappingURL=whicsToCommon.js.map